// extracted by mini-css-extract-plugin
module.exports = {"keySpecifierStyleWrapper":"v1_keySpecifierStyleWrapper__h5MK_"};